module.exports = __webpack_public_path__ + "img/form-2.01e964f.png";